module.exports = __webpack_public_path__ + "static/media/wewash.05ab41c8.svg";